<template>
  <div>
    个人信息
    <div class="personal">
      <div class="layout">
        <div class="bg" v-show="!redactShow">
          <img src="@/assets/images/shoujihaoma.png" alt="" />
        </div>
        <div class="container">
          <div class="phone">手机号码</div>
          <div v-show="!redactShow">
            <div v-if="userinfo.phone" class="content">
              {{ userinfo.phone }}
            </div>
            <div v-else class="content">暂无信息，请编辑</div>
          </div>
          <div class="edit" v-show="redactShow">
            <input type="text" v-model="from.phone" />
          </div>
        </div>
      </div>
      <div class="layout">
        <div class="bg" v-show="!redactShow">
          <img src="@/assets/images/qymc.png" alt="" />
        </div>
        <div class="container">
          <div class="phone">企业名称</div>
          <div v-show="!redactShow">
            <div v-if="userinfo.companyName" class="content">
              {{ userinfo.companyName }}
            </div>
            <div v-else class="content">暂无信息，请编辑</div>
          </div>
          <div class="edit" v-show="redactShow">
            <input type="text" v-model="from.companyName" />
          </div>
        </div>
      </div>
      <div class="layout">
        <div class="bg" v-show="!redactShow">
          <img src="@/assets/images/shxy.png" alt="" />
        </div>
        <div class="container">
          <div class="phone">社会信用代码</div>
          <div v-show="!redactShow">
            <div v-if="userinfo.identityCode" class="content">
              {{ userinfo.identityCode }}
            </div>
            <div v-else class="content">暂无信息，请编辑</div>
          </div>
          <div class="edit" v-show="redactShow">
            <input type="text" v-model="from.identityCode" />
          </div>
        </div>
      </div>
      <div class="layout">
        <div class="bg" v-show="!redactShow">
          <img src="@/assets/images/qyjj.png" alt="" />
        </div>
        <div class="container">
          <div class="phone">企业简介</div>
          <div v-show="!redactShow">
            <div v-if="userinfo.companySynopsis" class="content">
              {{ userinfo.companySynopsis }}
            </div>
            <div v-else class="content">暂无信息，请编辑</div>
          </div>
          <div class="edit" v-show="redactShow">
            <textarea v-model="from.companySynopsis"></textarea>
            <!-- <el-input type="textarea"   :autosize="{ minRows: 2, maxRows: 4}"  placeholder="请输入内容" v-model="from.companySynopsis">
                        </el-input> -->
          </div>
        </div>
      </div>
      <div style="display: flex">
        <div v-show="!redactShow" class="redact" @click="handleRedactShow()">
          编辑
        </div>
        <div v-show="!redactShow" class="redact" @click="logout()">
          退出登录
        </div>
      </div>
      <div v-show="redactShow" class="submit">
        <div class="save" @click="handleSubmit()">保存</div>
        <div class="cancel" @click="handleCancel()">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo, UserChange } from "@/api/login/index";
export default {
  data() {
    return {
      userinfo: {},
      redactShow: false,
      from: {},
    };
  },
  created() {
    this.initialize();
  },
  mounted() {
    this.$eventBus.on("isLogin", () => {
      this.initialize();
    });
  },
  methods: {
    initialize() {
      let token = sessionStorage.getItem("access_token")
        ? sessionStorage.getItem("access_token")
        : "";
      if (!token) {
        return;
      }

      getUserInfo().then((res) => {
        if (res.data.success) {
          this.userinfo = res.data.data;
          this.setSingleGlobalVariable(
            "userInfo",
            JSON.stringify(res.data.data)
          );
          // this.from = this.userinfo
        }
      });
    },
    // 编辑
    handleRedactShow() {
      this.redactShow = true;
      this.from = this.userinfo;
    },
    //保存
    async handleSubmit() {
      var reg = /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/;
      if (!reg.test(this.from.phone)) {
        this.$message.error("请输入正确手机号码");
        return;
      }
      if (!this.from.companyName) {
        this.$message.error("企业名称不能为空");
        return;
      }
      var code = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g;
      if (!code.test(this.from.identityCode)) {
        this.$message.error("请输入正确的社会信用代码");
        return;
      }
      if (!this.from.companySynopsis) {
        this.$message.error("企业简介不能为空");
        return;
      }
      await UserChange(this.from).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
        this.redactShow = false;
      });
    },
    // 取消
    handleCancel() {
      this.redactShow = false;
      this.initialize();
    },
    logout() {
      sessionStorage.clear();
      this.$emit("logout", false);
      this.$eventBus.emit("logout");
      // this.$router.push({path:"/"})
    },
  },
};
</script>

<style scoped>
.layout {
  display: flex;
  /* align-items: center; */
  margin-left: 20px;
  width: 100%;
  /* height: 60px; */
  margin-top: 15px;
  /* background: red; */
}

.bg img {
  width: 24px;
  height: 32px;
}

.container {
  margin-left: 20px;
}

.phone {
  font-size: 1rem;
  color: #212121;
}

.content {
  width: 300px;
  margin-top: 5px;
  color: #969696;
  font-size: 0.85rem;
  line-height: 20px;
}

.redact {
  width: 100px;
  background: #2c83f6;
  border-radius: 6px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
  cursor: pointer;
  font-size: 0.85rem;
  margin-top: 30px;
  margin-left: 38px;
}

.submit {
  width: 300px;
  height: 32px;
  margin-top: 30px;
  cursor: pointer;
  font-size: 0.85rem;
  color: #fff;
  display: flex;
  align-items: center;
  margin-left: 38px;
}

.save {
  width: 100px;
  background: #2c83f6;
  border-radius: 6px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #fff;
  cursor: pointer;
  font-size: 0.85rem;
  margin-right: 15px;
}

.cancel {
  width: 100px;
  border-radius: 6px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  color: #2c83f6;
  cursor: pointer;
  font-size: 0.85rem;
  border: 1px solid #2c83f6;
}

.edit input {
  width: 256px;
  height: 20px;
  background: #fff;
  font-size: 0.85rem;
  color: #969696;
  border: 1px solid #d5d5d5;
  line-height: 20px;
  margin-top: 10px;
  padding-left: 10px;
}

textarea {
  width: 256px;
  min-height: 100px;
  /* height: auto; */
  /* height: 20px; */
  background: #fff;
  font-size: 0.85rem;
  color: #969696;
  border: 1px solid #d5d5d5;
  line-height: 20px;
  margin-top: 10px;
  padding-left: 10px;
  outline: none;
}

textarea::-webkit-scrollbar {
  width: 4px;
}

textarea::-webkit-scrollbar-thumb {
  border-radius: 5px;
}
</style>